module.exports = __webpack_public_path__ + "img/rejecteddoc.aa5e951f.svg";